import React, { createContext, useContext, useState } from "react";

const BookingContext = createContext();

export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [pickUpDate, setPickUpDate] = useState("");
  const [dropOffDate, setDropOffDate] = useState("");

  return (
    <BookingContext.Provider value={{ pickUpDate, setPickUpDate, dropOffDate, setDropOffDate }}>
      {children}
    </BookingContext.Provider>
  );
};
